module.exports = __webpack_public_path__ + "img/2.fb588e2a.png";